import { Component, OnInit } from '@angular/core';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { ModuloEncuestaSubcategoriaService } from './modulo-encuesta-subcategoria.service';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from 'src/app/shared/models/confirmar-respuesta.model';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-modulo-encuesta-subcategoria',
  templateUrl: './modulo-encuesta-subcategoria.component.html',
  styleUrls: ['./modulo-encuesta-subcategoria.component.scss']
})
export class ModuloEncuestaSubcategoriaComponent implements OnInit {

  dataTabla: DatoPaginadoModel;
  headerModuloEncuestaSubcategoria: Array<string>;
  formModuloEncuestaSubcategoria: FormGroup;
  selectModuloEncuestaSubcategoria: any;
  paginaActual: number;

  // filtros
  filtro: FormGroup;
  public isCollapsed = true;

  // Selects
  subCategoria: Array<any>;
  moduloEncuestaByAnioFiltro: Array<any>;
  moduloEncuestaByAnio: Array<any>;

  constructor(private formBuilder: FormBuilder, private moduloEncuestaSubcategoriaService: ModuloEncuestaSubcategoriaService,
    private modalService: NgbModal) {
    this.dataTabla = {
      paging: {} as Paging
    } as DatoPaginadoModel;

    this.createForm();
    this.selectModuloEncuestaSubcategoria = null;
    this.paginaActual = 1;
  }

  ngOnInit() {
    this.headerModuloEncuestaSubcategoria = ['Módulo', 'SubCategoría', 'Año', 'Estado', 'Acción'];
    this.consultarListasFiltro();
    this.onConsultarModuloEncuestaSubcategoria(1);
    this.formModuloEncuestaSubcategoria.get("anio").valueChanges.pipe(debounceTime(500)).subscribe(x => {
      if (x?.length) {
        this.moduloEncuestaSubcategoriaService.getModuloEncuestaByAnio(x).subscribe(resultado => {
          if (resultado.data) {
            this.moduloEncuestaByAnio = resultado.data;
          }
        });
      } else {
        this.moduloEncuestaByAnio = [];
      }
      this.formModuloEncuestaSubcategoria.get("modulo_encuesta_id").patchValue(null);
    });
  }

  createForm() {
    this.formModuloEncuestaSubcategoria = this.formBuilder.group({
      modulo_encuesta_id: [null],
      sub_categoria_id: [null],
      anio: [null, Validators.required],
      activo: [true],
    });

    this.filtro = this.formBuilder.group({
      modulo_encuesta_id: [null],
      sub_categoria_id: [null],
      anio: [null],
      activo: [null],
    });
  }

  onConsultarModuloEncuestaSubcategoria(page: number) {
    this.moduloEncuestaSubcategoriaService.get({ ...this.filtro.value, numeroPagina: page })
      .subscribe(resultado => {
        if (resultado.result) {
          this.dataTabla = resultado.data as DatoPaginadoModel;
        }
      });
  }

  onPaginado(value: number) {
    this.paginaActual = value;
    this.onConsultarModuloEncuestaSubcategoria(value);
  }

  onAgregarModuloEncuestaSubcategoria() {
    this.moduloEncuestaSubcategoriaService.create({
      ...this.formModuloEncuestaSubcategoria.value, activo: 1
    })
      .subscribe(resultado => {
        if (resultado.result) {
          this.onConsultarModuloEncuestaSubcategoria(this.paginaActual);
          this.formModuloEncuestaSubcategoria.reset();
        }
      });
  }

  onOperarModuloEncuestaSubcategoria() {
    if (!this.selectModuloEncuestaSubcategoria) {
      this.onAgregarModuloEncuestaSubcategoria();
    } else {
      this.onModificarModuloEncuestaSubcategoria();
    }
  }

  onCargarModuloEncuestaSubcategoria(entry: any) {
    entry.activo = entry.activo ? 1 : 0;
    this.formModuloEncuestaSubcategoria.patchValue({
      ...entry,
    }, { emitEvent: false });

    if (entry.anio) {
      this.moduloEncuestaSubcategoriaService.getModuloEncuestaByAnio(entry.anio).subscribe(resultado => {
        if (resultado.data) {
          this.moduloEncuestaByAnio = resultado.data;
        }
      });
    }

    this.selectModuloEncuestaSubcategoria = entry;
    this.formModuloEncuestaSubcategoria.get('modulo_encuesta_id').disable();
    this.formModuloEncuestaSubcategoria.get('sub_categoria_id').disable();
    this.formModuloEncuestaSubcategoria.get('anio').disable({ emitEvent: false });
  }

  onEliminarModuloEncuestaSubcategoria(entry: any) {
    const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
    const confirmarRespuesta = {} as ConfirmarRespuestaModel;
    confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
    confirmarRespuesta.message = `¿Está seguro de eliminar la configuración seleccionada?`;
    modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
    modalRef.result.then(() => {
      this.moduloEncuestaSubcategoriaService.delete(entry).subscribe(resultado => {
        if (resultado.result) {
          // tslint:disable-next-line:max-line-length
          const index = this.dataTabla.items
            // tslint:disable-next-line:no-shadowed-variable
            .findIndex(e => {
              if (e.modulo_encuesta_id === entry.modulo_encuesta_id &&
                e.sub_categoria_id === entry.sub_categoria_id &&
                e.anio === entry.anio) {
                return true;
              }
            });
          this.dataTabla.items.splice(index, 1);
          this.selectModuloEncuestaSubcategoria = null;
          this.formModuloEncuestaSubcategoria.reset();
        }
      });
    });
  }

  onModificarModuloEncuestaSubcategoria() {
    this.moduloEncuestaSubcategoriaService.update({
      ...this.formModuloEncuestaSubcategoria.value,
      modulo_encuesta_id: this.selectModuloEncuestaSubcategoria.modulo_encuesta_id,
      sub_categoria_id: this.selectModuloEncuestaSubcategoria.sub_categoria_id,
      anio: this.selectModuloEncuestaSubcategoria.anio
    })
      .subscribe(resultado => {
        if (resultado.result) {
          this.onConsultarModuloEncuestaSubcategoria(this.paginaActual);
          this.formModuloEncuestaSubcategoria.get('modulo_encuesta_id').enable();
          this.formModuloEncuestaSubcategoria.get('sub_categoria_id').enable();
          this.formModuloEncuestaSubcategoria.get('anio').enable();
          this.formModuloEncuestaSubcategoria.reset();
          this.selectModuloEncuestaSubcategoria = null;
        }
      });
  }

  consultarListasFiltro() {
    this.filtro.get("anio").valueChanges.pipe(debounceTime(500)).subscribe(x => {
      if (x?.length) {
        this.moduloEncuestaSubcategoriaService.getModuloEncuestaByAnio(x).subscribe(resultado => {
          if (resultado.data) {
            this.moduloEncuestaByAnioFiltro = resultado.data;
          }
        });
      } else {
        this.moduloEncuestaByAnioFiltro = [];
      }
      this.filtro.get("modulo_encuesta_id").patchValue(null);
    });

    this.moduloEncuestaSubcategoriaService.getSubCategoria().subscribe(resultado => {
      if (resultado.data) {
        this.subCategoria = resultado.data;
      }
    });
  }

  filtrar() {
    this.paginaActual = 1;
    this.onConsultarModuloEncuestaSubcategoria(1);
  }

  limpiar() {
    this.filtro.reset();
    this.filtrar();
  }
  limpiarModuloEncuestaSubcategoria() {
    this.formModuloEncuestaSubcategoria.reset();
    this.selectModuloEncuestaSubcategoria = null;
    this.createForm();
  }
}
